import { useUserStore } from "@/stores/userStore";
import { useLoaderStore } from "@/stores/loaderStore";
import { useSuccessStore } from "@/stores/successStore";
import { useErrorStore } from "@/stores/errorStore";
import { useBaseStore } from "@/stores/baseStore";

export default {
  install: (app) => {
    // Instanzen der Stores erstellen

    const userStore = useUserStore();
    const loaderStore = useLoaderStore();
    const successStore = useSuccessStore();
    const errorStore = useErrorStore();
    const baseStore = useBaseStore();
    // Stores als globale Provider bereitstellen

    app.provide('userStore', userStore);
    app.provide('loaderStore', loaderStore);
    app.provide('successStore', successStore);
    app.provide('errorStore', errorStore);
    app.provide('baseStore', baseStore);
    // Optional: Als globale Eigenschaften festlegen (weniger empfohlen)
    app.config.globalProperties.$userStore = userStore;
    app.config.globalProperties.$loaderStore = loaderStore;
    app.config.globalProperties.$successStore = successStore;
    app.config.globalProperties.$errorStore = errorStore;
    app.config.globalProperties.$baseStore = baseStore;
  }
};
